import { createFileRoute } from '@tanstack/react-router'

import { anyOfPermissions } from '@orus.eu/right-access-management'

import { SubscriptionsDataGridPage } from '../../../components/pages/backoffice/subscriptions-data-grid-page.tsx'
import { PermissionChecker } from '../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/subscriptions/')({
  component: function Component() {
    return (
      <PermissionChecker requiredPermissions={[anyOfPermissions('subscription.read', 'subscription.read.relatedOnly')]}>
        <SubscriptionsDataGridPage />
      </PermissionChecker>
    )
  },
})
